
  var Global_Acct_Invoice_bIsBusy = 0;

  function Meta_Acct_Invoice( CommandKey,
                              CommandValue1,
                              CommandValue2,
                              CommandValue3,
                              CommandValue4,
                              CommandValue5 = 'inv-app-output',
                              CommandValue6 = '')
  {
    var postcode=0;

    
    if ( Global_Acct_Invoice_bIsBusy == 1 )
    {
      // console.log('Global_Acct_Invoice_bIsBusy = 1 ignore');
      return;
    }
    
    Global_Acct_Invoice_bIsBusy = 1;

    // Create form data
    var formData = new FormData();
    
    formData.append("Field_CommandKey",CommandKey);       // P 
    formData.append("Field_CommandValue1",CommandValue1); // OrderId
    formData.append("Field_CommandValue2",CommandValue2); // StoreID
    formData.append("Field_CommandValue3",CommandValue3); // OrderName
    formData.append("Field_CommandValue4",CommandValue4); // GMSD
    
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange =
      function(e)
      {
        if (xhr.readyState == 4)
        {
          if ( xhr.status == 200 )
          {
            // console.log( xhr.responseText );
            
            switch( xhr.responseText[0] )
            {
              case '!':
                // error
                console.log(  'Acct_Invoice ERROR [' + CommandKey + '] >>> ' + xhr.responseText );
                // window.location="/login";
              break;

              default:
                 postcode=1;
                
                 // console.log( 'Acct_Invoice [' + CommandKey + '] >>> ' + xhr.responseText );

                 switch ( CommandKey )
                 {
                     
                   case 'S': // Select
                      // document.getElementById('inv-app-output').innerHTML = xhr.responseText;
                     document.getElementById(CommandValue5).innerHTML = xhr.responseText;
                   break;
                     
                   case 'R': // Pull RSM
                      document.getElementById(CommandValue5).innerHTML = xhr.responseText;
                      document.getElementById(CommandValue6).value = 1;
                   break;
                 }

              break;
            }
 
          }
          else
          {
            // fail
          }
          
          Global_Acct_Invoice_bIsBusy = 0;
          
        }
      };

    xhr.open("POST", "https://portal.ruggedradios.com/shopify-dealer-invoice-gql/" , true);

    xhr.send(formData);

   
    
    return postcode;    
  }



  function HandleGetInvoice( this_MSD, this_OrderName )
  {
    Meta_Acct_Invoice('S','','B',this_OrderName,this_MSD);
  }

  function HandleRSMGetInvoice( this_OrderName , this_target_div , this_oneshot_id)
  {
    console.log('HandleRSMGetInvoice ['+this_OrderName+']['+this_target_div+']['+this_oneshot_id+']');
    Meta_Acct_Invoice('R','','B',this_OrderName,'',this_target_div,this_oneshot_id);
  }




